export default function Logo() {
  return (
    <svg width={28} height={28} viewBox="0 0 48 48" fill="none">
      <g filter="url(#filter0_iii_3051_46991)">
        <g clipPath="url(#clip0_3051_46991)">
          <rect width={48} height={48} rx={12} fill="#6d28d9" />
          <rect width={48} height={48} fill="url(#paint0_linear_3051_46991)" />
          <g filter="url(#filter1_d_3051_46991)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M22.875 20.25V9L25.125 9V20.25H22.875Z"
              fill="url(#paint1_linear_3051_46991)"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M22.875 39V27.75H25.125V39H22.875Z"
              fill="url(#paint2_linear_3051_46991)"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M25.8566 20.553L33.8115 12.598L35.4025 14.189L29.0386 20.553L25.8566 20.553Z"
              fill="url(#paint3_linear_3051_46991)"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12.5983 33.8112L20.5533 25.8563L22.1443 27.4473L14.1893 35.4022L12.5983 33.8112Z"
              fill="url(#paint4_linear_3051_46991)"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M29.0384 27.4472L35.4023 33.8112L33.8114 35.4021L25.8564 27.4472H29.0384Z"
              fill="url(#paint5_linear_3051_46991)"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M14.1891 12.598L22.1441 20.5529L20.5531 22.1439L12.5982 14.1889L14.1891 12.598Z"
              fill="url(#paint6_linear_3051_46991)"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M22.875 22.875L39 22.875V25.125L22.875 25.125V22.875Z"
              fill="url(#paint7_linear_3051_46991)"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9 22.875L20.25 22.875V25.125L9 25.125L9 22.875Z"
              fill="url(#paint8_linear_3051_46991)"
            />
          </g>
        </g>
        <rect
          x={1}
          y={1}
          width={46}
          height={46}
          rx={11}
          stroke="url(#paint9_linear_3051_46991)"
          strokeWidth={2}
        />
      </g>
      <defs>
        <filter
          id="filter0_iii_3051_46991"
          x={0}
          y={-3}
          width={48}
          height={54}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={-3} />
          <feGaussianBlur stdDeviation={1.5} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_3051_46991"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={3} />
          <feGaussianBlur stdDeviation={1.5} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_innerShadow_3051_46991"
            result="effect2_innerShadow_3051_46991"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius={1}
            operator="erode"
            in="SourceAlpha"
            result="effect3_innerShadow_3051_46991"
          />
          <feOffset />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_innerShadow_3051_46991"
            result="effect3_innerShadow_3051_46991"
          />
        </filter>
        <filter
          id="filter1_d_3051_46991"
          x={6}
          y={5.25}
          width={36}
          height={42}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius={1.5}
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_3051_46991"
          />
          <feOffset dy={2.25} />
          <feGaussianBlur stdDeviation={2.25} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.141176 0 0 0 0 0.141176 0 0 0 0 0.141176 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3051_46991"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3051_46991"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_3051_46991"
          x1={24}
          y1={5.96047e-7}
          x2={26}
          y2={48}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity={0} />
          <stop offset={1} stopColor="white" stopOpacity={0.12} />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3051_46991"
          x1={24}
          y1={9}
          x2={24}
          y2={39}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity={0.8} />
          <stop offset={1} stopColor="white" stopOpacity={0.5} />
        </linearGradient>
        <linearGradient
          id="paint2_linear_3051_46991"
          x1={24}
          y1={9}
          x2={24}
          y2={39}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity={0.8} />
          <stop offset={1} stopColor="white" stopOpacity={0.5} />
        </linearGradient>
        <linearGradient
          id="paint3_linear_3051_46991"
          x1={24}
          y1={9}
          x2={24}
          y2={39}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity={0.8} />
          <stop offset={1} stopColor="white" stopOpacity={0.5} />
        </linearGradient>
        <linearGradient
          id="paint4_linear_3051_46991"
          x1={24}
          y1={9}
          x2={24}
          y2={39}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity={0.8} />
          <stop offset={1} stopColor="white" stopOpacity={0.5} />
        </linearGradient>
        <linearGradient
          id="paint5_linear_3051_46991"
          x1={24}
          y1={9}
          x2={24}
          y2={39}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity={0.8} />
          <stop offset={1} stopColor="white" stopOpacity={0.5} />
        </linearGradient>
        <linearGradient
          id="paint6_linear_3051_46991"
          x1={24}
          y1={9}
          x2={24}
          y2={39}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity={0.8} />
          <stop offset={1} stopColor="white" stopOpacity={0.5} />
        </linearGradient>
        <linearGradient
          id="paint7_linear_3051_46991"
          x1={24}
          y1={9}
          x2={24}
          y2={39}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity={0.8} />
          <stop offset={1} stopColor="white" stopOpacity={0.5} />
        </linearGradient>
        <linearGradient
          id="paint8_linear_3051_46991"
          x1={24}
          y1={9}
          x2={24}
          y2={39}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity={0.8} />
          <stop offset={1} stopColor="white" stopOpacity={0.5} />
        </linearGradient>
        <linearGradient
          id="paint9_linear_3051_46991"
          x1={24}
          y1={0}
          x2={24}
          y2={48}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity={0.12} />
          <stop offset={1} stopColor="white" stopOpacity={0} />
        </linearGradient>
        <clipPath id="clip0_3051_46991">
          <rect width={48} height={48} rx={12} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
